<template>
  <guest-layout>
    <template #header>
      <font-awesome-icon icon="fas fa-circle-exclamation" />
    </template>
    <Head title="Register" />
    <div class="container flex flex-wrap justify-between p-6 mx-auto my-4 mt-6 max-w-7xl">
      <div class="w-full max-w-6xl bg-white rounded-lg shadow-xl md:flex">
        <div class="w-full md:w-6/12 lg:w-5/12">
          <form class="mt-8 overflow-hidden bg-white rounded-bl-lg" @submit.prevent="register">
            <div class="px-10 py-2">
              <h1 class="text-2xl font-bold text-center">Pendaftaran</h1>
              <div class="w-24 mx-auto mt-6 border-b-2" />
              <text-input v-model="form.fullname" :error="form.errors.fullname" class="mt-10" placeholder="Nama Lengkap Sesuai KTP/KK" type="text" autofocus autocapitalize="off" maxlength="150" />
              <label class="flex items-center mt-10 select-none">Daftar User untuk Login :</label>
              <text-input v-model="form.username" :error="form.errors.username || nikError" class="mt-6" placeholder="NIK" type="text" autofocus autocapitalize="off" maxlength="16" />

              <text-input v-model="form.email" :error="form.errors.email || emailError" class="mt-6" placeholder="Email" type="email" autocomplete="email" />

              <text-input v-model="form.password" :error="form.errors.password" class="mt-6" placeholder="Password" type="password" autocomplete="off" />
              <ul v-if="form.password.length > 0 && !valid_password" class="mt-2 ml-4 list-disc">
                <li :class="{ 'form-error': !contains_eight_characters, 'form-valid': contains_eight_characters }">
                  Minimal 8 Karakter <font-awesome-icon v-if="contains_eight_characters" icon="fas fa-check" class="text-green-700" />
                </li>
                <li :class="{ 'form-error': !contains_number, 'form-valid': contains_number }">
                  Mengandung angka <font-awesome-icon v-if="contains_number" icon="fas fa-check" class="text-green-700" />
                </li>
                <li :class="{ 'form-error': !contains_uppercase, 'form-valid': contains_uppercase }">
                  Mengandung huruf kapital <font-awesome-icon v-if="contains_uppercase" icon="fas fa-check" class="text-green-700" />
                </li>
                <li :class="{ 'form-error': !contains_special_character, 'form-valid': contains_special_character }">
                  Mengandung karakter khusus <font-awesome-icon v-if="contains_special_character" icon="fas fa-check" class="text-green-700" />
                </li>
              </ul>

              <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" placeholder="Confirm Password" type="password" />
              <div v-if="form.password_confirmation !== '' && !passwordMatch" class="form-error">Password tidak sama</div>
              <vue-recaptcha
                ref="recaptcha"
                class="mt-6"
                :sitekey="siteKey"
                :load-recaptcha-script="true"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
              />
              <div v-if="form.errors.recaptcha" class="form-error">Recaptcha tidak valid</div>
              <label class="flex items-center mt-6 select-none">
                <span class="text-sm">*Catat dan ingat User ID dan Password anda sebelum klik Daftar!!</span>
              </label>
              <hr class="mt-4" />
              <loading-button :loading="form.processing" class="mt-6 btn-green" type="submit">
                <font-awesome-icon icon="fas fa-user" />&nbsp;Daftar
              </loading-button>
            </div>
          </form>
        </div>
        <div class="relative hidden w-0 rounded-tr-lg rounded-br-lg md:w-6/12 lg:w-7/12 md:flex md:flex-col">
          <img src="/images/background.png" alt="Background" class="flex-1 object-cover" />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { VueRecaptcha } from 'vue-recaptcha'
import GuestLayout from '../../Layouts/GuestLayout.vue'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
    VueRecaptcha,
    GuestLayout,
  },
  data() {
    return {
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password: false,
      nikError: '',
      emailError: '',
      form: this.$inertia.form({
        fullname: '',
        username: '',
        email: '',
        password: '',
        password_confirmation: '',
        remember: false,
        recaptcha: '',
      }),
      siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    }
  },

  computed: {
    passwordMatch() {
      return this.form.password_confirmation === '' || (this.form.password === this.form.password_confirmation)
    },
  },

  watch: {
    'form.password' (newValue) {
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/

      this.contains_eight_characters = newValue.length >= 8
      this.contains_number = /\d/.test(newValue)
      this.contains_uppercase = /[A-Z]/.test(newValue)
      this.contains_special_character = format.test(newValue)

      this.valid_password = this.contains_eight_characters &&
                            this.contains_special_character &&
                            this.contains_uppercase &&
                            this.contains_number
    },
    'form.username': {
      handler(newValue) {
        this.validateNik(newValue)
      },
      immediate: true,
    },
    'form.email': {
      handler(newValue) {
        this.validateEmail(newValue)
      },
      immediate: true,
    },
  },
  methods: {
    validateEmail(email) {
      if (email.length === 0) {
        this.emailError = ''
        return
      }
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(email)) {
        this.emailError = 'Format email tidak valid.'
      } else {
        this.emailError = ''
      }
    },
    validateNik(nik) {
      const nikRegex = /^\d{6}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/

      if (nik.length === 0) {
        this.nikError = ''
        return
      }

      if (nik.length !== 16) {
        this.nikError = 'NIK harus terdiri dari 16 digit angka.'
        return
      }

      if (!/^\d+$/.test(nik)) {
        this.nikError = 'NIK hanya boleh berisi angka.'
        return
      }

      if (!nikRegex.test(nik)) {
        this.nikError = 'Format NIK tidak valid.'
      } else {
        this.nikError = ''
      }
    },
    register() {
      this.form.clearErrors('username')
      this.form.clearErrors('email')
      this.form.clearErrors('password')
      this.form.clearErrors('password_confirmation')
      this.form.clearErrors('recaptcha')
      this.form.clearErrors('fullname')

      let hasError = false

      this.validateNik(this.form.username)
      if (this.nikError) {
        hasError = true
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi Gagal',
          text: this.nikError,
        })
        return
      }

      if (!this.form.fullname || this.form.fullname.trim() === '') {
        this.form.errors.fullname = 'Nama Lengkap wajib diisi.'
        hasError = true
      } else {
        delete this.form.errors.fullname
      }

      this.validateEmail(this.form.email)
      if (this.emailError) {
        hasError = true
        this.$swal.fire({ icon: 'error', title: 'Validasi Gagal', text: this.emailError })
        return
      }
      if (!this.form.email) {
        this.form.errors.email = 'Email wajib diisi.'
        hasError = true
      } else {
        delete this.form.errors.email
      }


      if (!this.form.password) {
        this.form.errors.password = 'Password wajib diisi.'
        hasError = true
      } else if (!this.valid_password) {
        this.form.errors.password = 'Password tidak memenuhi kriteria keamanan!'
        hasError = true
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi Gagal',
          text: 'Password tidak memenuhi kriteria keamanan!',
        })
        return
      } else {
        delete this.form.errors.password
      }

      if (!this.form.password_confirmation) {
        this.form.errors.password_confirmation = 'Konfirmasi Password wajib diisi.'
        hasError = true
      } else if (!this.passwordMatch) {
        this.form.errors.password_confirmation = 'Konfirmasi Password tidak cocok!'
        hasError = true
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi Gagal',
          text: 'Konfirmasi Password tidak cocok!',
        })
        return
      } else {
        delete this.form.errors.password_confirmation
      }

      if (!this.form.recaptcha) {
        this.form.errors.recaptcha = 'Silakan centang reCAPTCHA.'
        hasError = true
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi Gagal',
          text: 'Silakan centang reCAPTCHA.',
        })
        return
      } else {
        delete this.form.errors.recaptcha
      }

      if (hasError) {
        return
      }

      this.$swal.fire({
        title: 'Konfirmasi Pernyataan',
        text: 'Dengan melakukan pendaftaran, saya menyatakan bahwa telah tinggal di Kota Cilegon lebih atau sama dengan 5 (lima) tahun. Saya bersedia dituntut dimuka pengadilan serta bersedia memenuhi segala tindakan yang diambil oleh pemerintah, apabila dikemudian hari terbukti pernyataan saya ini tidak benar.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Setuju',
        cancelButtonText: 'Batal',
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.post('/register')
          this.onCaptchaExpired()
        }
      })
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.form.recaptcha = recaptchaToken
      delete this.form.errors.recaptcha
    },
    onCaptchaExpired: function () {
      this.form.recaptcha = ''
      this.$refs.recaptcha.reset()
      this.form.errors.recaptcha = 'reCAPTCHA kadaluarsa, silakan coba lagi.'
    },
  },
}
</script>

<style scoped>
.form-error {
  color: #ef4444;
  font-size: 0.875rem;
}
.form-valid {
  color: #15803d;
  font-size: 0.875rem;
}
</style>
